import { createReducer, on } from '@ngrx/store';
import { UiActions } from './ui.actions';
import { initialUiState } from './ui.state';

export const uiReducer = createReducer(
    initialUiState,
    on(UiActions.setGlobalLoading, (state, { loading }) => ({ ...state, globalLoading: loading })),
    on(UiActions.toggleSidenav, state => ({ ...state, sidenavOpen: !state.sidenavOpen })),
    on(UiActions.openSidenav,   state => ({ ...state, sidenavOpen: true })),
    on(UiActions.closeSidenav,  state => ({ ...state, sidenavOpen: false })),
    on(UiActions.loadNavigation, state => ({ ...state, navLoading: true })),
    on(UiActions.loadNavigationSuccess, (state, { leftNav, rightNav, searchBoxVisible }) =>
        ({ ...state, navLoading: false, leftNav, rightNav, searchBoxVisible })),
    on(UiActions.loadNavigationFailure, state => ({ ...state, navLoading: false })),
    on(UiActions.loadReleaseInfoSuccess, (state, { buildNumber, buildDate, versionNumber }) =>
        ({ ...state, buildNumber, buildDate, versionNumber })),
    on(UiActions.loadReleaseInfoFailure, state => ({ ...state })),
);
